import { useEffect, useState } from 'react';

// [TODO-781]:
//  - We shouldn't be setting arbitrary window messages here, add some guards in
//  - Also all mouse movements are causing re-renders, extremely unperformant
//    - Remove setState or throttle
export default function usePlayerEvent() {
  const [msg, setMsg] = useState<MessageEvent>()

  useEffect(() => {
    const handleMsgRec = (e) => {
      // React Dev Tools uses window.postMessage very often, ignore these messages
      // https://github.com/facebook/react-devtools/issues/812#issuecomment-308827334
      if (e?.data?.source !== 'react-devtools-bridge') {
        setMsg(e)
      }
    }

    window.addEventListener('message', handleMsgRec)
    return () => {
      window.removeEventListener('message', handleMsgRec)
    }
  }, [])

  return msg
}
